// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root .boTpo{height:0;left:-9999px;position:absolute;top:var(--anchore-page-offset-top);visibility:hidden;width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `boTpo`
};
module.exports = ___CSS_LOADER_EXPORT___;
